/**
 * checkSiren — vérifie qu'une fiche entreprise a un SIREN renseigné.
 * À appeler dès la sélection d'un client/fournisseur dans n'importe quel document.
 *
 * Règle : entreprise française (pays_code === 'FR' ou non renseigné) → SIREN obligatoire.
 *         entreprise étrangère → pas de vérification (identifiée par IBAN).
 *
 * @param {object} ent  fiche entreprise (doit contenir au moins siren, pays_code)
 * @returns {boolean}   true si OK, false si SIREN manquant (toast déclenché)
 */
import { toast } from 'sonner';

export function checkSiren(ent) {
  if (!ent) return true; // pas de fiche chargée, on ne bloque pas
  const isForeign = ent.pays_code && ent.pays_code !== 'FR';
  if (isForeign) return true;
  if (ent.siren && ent.siren.trim()) return true;

  toast.warning('Siren manquant dans la fiche - Complétez via Pappers', {
    duration: 6000,
    id: 'siren-missing', // déduplique les toasts si sélection rapide
  });
  return false;
}
